var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.652 7.49243C13.4777 7.49243 16.1443 7.76757 18.1834 8.01957C19.7443 8.20986 20.7369 9.77586 20.1172 11.2184C18.618 14.7001 16.2986 17.9299 12.8014 20.0899C12.4561 20.3034 12.0581 20.4165 11.652 20.4165C11.246 20.4165 10.848 20.3034 10.5026 20.0899C7.00545 17.9299 4.68602 14.7001 3.18688 11.2184C2.56716 9.77586 3.55973 8.20986 5.11802 8.01957C7.15973 7.77015 9.8263 7.49243 11.652 7.49243Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select-arrow.7ae167edc1a12debf40e8e04ab73d15d.svg";
export { ForwardRef as ReactComponent };